<template>
  <section class="ai-visibility-question-summary" aria-label="Questions summary">
    <div class="ai-visibility-question-summary__total">
      <strong>{{ summary.total }}</strong>
      <div class="side-text">
        <span>Questions tracked</span>
        <span>in your space</span>
      </div>
    </div>
    <div class="ai-visibility-question-summary__bars">
      <span class="ai-visibility-question-summary__bar ai-visibility-question-summary__bar--winning">
        {{ summary.winning }} winning · you rank top 3
      </span>
      <span class="ai-visibility-question-summary__bar ai-visibility-question-summary__bar--slipping">
        {{ summary.slipping }} slipping · you're dropping
      </span>
      <span class="ai-visibility-question-summary__bar ai-visibility-question-summary__bar--missing">
        {{ summary.missing }} missing · not in answer
      </span>
      <span class="ai-visibility-question-summary__bar ai-visibility-question-summary__bar--holding">
        {{ summary.holding }} holding · you're in, lower rank
      </span>
    </div>
    <div class="ai-visibility-question-summary__opening">
      <span>Biggest opening</span>
      <strong>{{ biggestOpeningLabel }}</strong>
      <small v-if="summary.biggestOpening && summary.biggestOpening.detail">
        {{ summary.biggestOpening.detail }}
      </small>
    </div>
  </section>
</template>

<script>
export default {
  name: 'QuestionSummaryBar',
  props: {
    summary: {
      type: Object,
      required: true,
    },
  },
  computed: {
    biggestOpeningLabel () {
      return this.summary.biggestOpening?.label || '0 missing'
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-question-summary {
  display: flex;
  overflow: hidden;
  align-items: stretch;
  min-width: 0;
  border: 1px solid #FFE9DE;
  border-radius: 16px;
  background: linear-gradient(69deg, #FFF 65.79%, #FFF3ED 98.62%);;
  box-shadow: 0 5px 2px 0 rgba(0, 0, 0, 0.01), 0 3px 2px 0 rgba(0, 0, 0, 0.04), 0 1px 1px 0 rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.08);
}

.ai-visibility-question-summary__total,
.ai-visibility-question-summary__opening {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  padding: 16px;
}

.ai-visibility-question-summary__total {
  flex-direction: row;
  align-items: center;
  gap: 10px;
  flex: 0 0 200px;

  strong {
    font-size: 36px;
    color: var(--v-mainColor-base);
    font-weight: 700;
  }

  .side-text {
    display: flex;
    flex-direction: column;
    gap: 4px;

    span {
      font-size: 14px;
      font-weight: 500;

      &:first-child {
        color: var(--v-mainColor-base);
      }

      &:last-child {
        color: var(--v-darkGrayColor-base);
      }

    }

  }

  &::after {
    content: '';
    border-right: 1px solid #DADADA;
    height: 65%;
  }
}

.ai-visibility-question-summary__opening strong {
  color: #363636;
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
}

.ai-visibility-question-summary__total span,
.ai-visibility-question-summary__opening span,
.ai-visibility-question-summary__opening small {
  color: var(--v-mainColor-base);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
}

.ai-visibility-question-summary__bars {
  display: flex;
  flex: 1;
  align-items: center;
  min-width: 0;
  padding: 16px 0;
  gap: 1px;
}

.ai-visibility-question-summary__bar {
  display: inline-flex;
  min-height: 42px;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  color: var(--v-whiteColor-base);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  min-width: 0;
  padding: 6px 8px;
  text-align: center;
  overflow-wrap: anywhere;
}

.ai-visibility-question-summary__bar--winning {
  background: var(--v-green7Color-base);
  border-radius: 5px 0 0 5px;
}

.ai-visibility-question-summary__bar--slipping {
  background: var(--v-profileAnchorColor-base);
}

.ai-visibility-question-summary__bar--missing {
  background: var(--v-red11Color-base);
}

.ai-visibility-question-summary__bar--holding {
  background: var(--v-link4Color-base);
  border-radius: 0 5px 5px 0;
}

.ai-visibility-question-summary__opening {
  align-items: flex-end;
  text-align: right;
  position: relative;
  flex: 0 0 240px;

  &::before {
    content: '';
    border-left: 1px solid #DADADA;
    height: 70%;
    position: absolute;
    left: 20px;
  }
}

@media (max-width: 760px) {
  .ai-visibility-question-summary,
  .ai-visibility-question-summary__bars {
    flex-direction: column;
  }

  .ai-visibility-question-summary__total,
  .ai-visibility-question-summary__opening {
    flex-basis: auto;
    align-items: flex-start;
    text-align: left;
  }

  .ai-visibility-question-summary__opening {
    border-left: 0;
    border-top: 1px solid var(--v-gray13Color-base);
  }

  .ai-visibility-question-summary__bars {
    align-items: stretch;
    padding: 0 16px 16px;
  }

  .ai-visibility-question-summary__bar {
    justify-content: flex-start;
  }
}
</style>
